export default __webpack_public_path__ + "static/media/wordlogo.e586beb1.JPG";